var _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgIsotherownerProfile = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#2E2E2E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "isotherowner-profile_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.268 6.268 0 14 0s14 6.268 14 14-6.268 14-14 14S0 21.732 0 14Z",
    fill: "#2E2E2E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#isotherowner-profile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.625 10.625a5.632 5.632 0 0 0 5.625 5.625 5.632 5.632 0 0 0 5.625-5.625A5.632 5.632 0 0 0 14.25 5a5.632 5.632 0 0 0-5.625 5.625ZM24.25 28.75h1.25V27.5c0-4.824-3.926-8.75-8.75-8.75h-5C6.925 18.75 3 22.676 3 27.5v1.25h21.25Z",
    fill: "#F0F0F0"
  }))));
};
export { SvgIsotherownerProfile as ReactComponent };
export default __webpack_public_path__ + "c2bd600a504b759a8ef107ed73b73c31.svg";